import styled from 'styled-components';

export const CEMPackageDetailContainer = styled.div`
  max-width: 850px;
  padding: 18px 0 0 13px;
`;
